<script setup lang="ts">
  defineProps<{
    label: string;
    value?: string | number | null;
  }>();
</script>

<template>
  <li class="flex">
    <span class="font-medium text-foreground w-32 shrink-0">{{ label }}</span>
    <span class="text-foreground/80">{{ value || "--" }}</span>
  </li>
</template>
